import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject, OnInit, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { userDefinition as baseUserDefinition } from '../../../../entity-definitions/user.definition';
import { UserStore } from '../../../../stores/user.store';
import { EntityDefinition } from '../../../../types/entity-definition.interface';
import { User } from '../../../../types/user.interface';
import { GenericParentGridComponent } from '../../../generic/generic-parent-grid.component';
import { CesTitleComponent } from '../../../ui/ces-route-title/ces-route-title.component';

@Component({
  selector: 'app-users',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CesTitleComponent, GenericParentGridComponent],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css',
})
export class UsersComponent implements OnInit {
  protected readonly userStore = inject(UserStore);
  protected readonly router = inject(Router);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly translateService = inject(TranslocoService);

  dataLoadingCompleted: boolean = false;
  readonly userDefinition = computed(
    (): EntityDefinition<User> => ({
      ...baseUserDefinition,
      rowLinkHref: user => [this.router.url, user.id],
    }),
  );

  readonly users: Signal<User[]> = this.userStore.assignableUsers;

  ngOnInit(): void {
    void this.loadData();
  }

  private async loadData(): Promise<void> {
    try {
      await this.userStore.loadAll();
      this.dataLoadingCompleted = true;
    } catch (error) {
      console.error(this.translateService.translate('common.errors.dataLoadFailed'), error);
    } finally {
      this.cdr.markForCheck();
    }
  }
}
